import { SecurityService } from './../../core/services/security.service';
import { Component, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../app.service';
import { ListPageBase } from '../../shared/components/list-page-base/list-page-base';
import { RequestListItem } from '../../shared/models/request/request-list-item';
import { RequestsService } from '../../shared/services/requests.service';
import { LookupService } from '../../shared/services/lookup.service';
import { KeyValueObject } from '../../shared/models/core/KeyValueObject';
import { CompositeFilterDescriptor, DataSourceRequestState, FilterDescriptor } from '@progress/kendo-data-query';
import { from, fromEvent, interval, Observable, Subject, Subscription } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, tap, filter, takeUntil } from 'rxjs/operators';
import { StatePersistingService } from '../../shared/services/state-persisting.service';
import { GridSettings } from '../../shared/models/grid/grid-settings';
import { ActivityStatusEnum, RequestStatus, RequestType } from '../../shared/enums';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { MultipleOperationsComponent } from '../../shared/components/multiple-operations/multiple-operations.component';
import { NotificationService } from '../../core/services/notification.service';
import { NotificationType } from '../../core/services/notification-type';
import { CheckboxColumnComponent, ColumnBase, ColumnChooserComponent, ColumnComponent, ColumnVisibilityChangeEvent, GridComponent, RowClassArgs } from '@progress/kendo-angular-grid';
import { UserFiltersService } from '../../shared/services/user-filters.service';
import { UserFilter } from '../../shared/models/user-filter/user-filter';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RequestNotificationTypeService } from '../../shared/services/request-notification-type.service';
import { RequestNotificationType } from '../../shared/models/request/request-notification-type';
import { MapYaComponent } from '../map-ya/map-ya.component';
import { MapYaDataService } from '../../shared/services/map-ya-data.service';

import { environment } from '../../../environments/environment';
import { saveAs } from 'file-saver';
import { ColumnSettings } from '../../shared/models/grid/column-settings';
import { MultipleOperationErrorResultComponent } from '../../shared/components/multiple-operations/multiple-operation-error-result/multiple-operation-error-result.component';
import { UserGroupsService } from '../../shared/services/user-groups.service';
import { SignalRNotificationsService } from '../../shared/services/signalr-notifications.service';
import { LoadFinancialReconciliationWarningComponent } from '../../shared/components/financial-reconciliation-warning/financial-reconciliation-warning';
import { UserFilterType } from '../../shared/enums/user-filter-type.enum';
import { VeerouteCalendarComponent } from '../veeroute/veeroute-calendar.component';
import { ContragentsService } from '../../categories/contragents/contragents.service';
import {UsersService} from "../../admin/users/users.service";
import {InitTypesService} from "../../shared/services/init-types.service";
import {RequestStatusesService} from "../../shared/services/request-statuses.service";
import {RequestStatusMspAliasGroupsService} from "../../shared/services/request-status-msp-alias-groups.service";
import {ActivityStatusesService} from "../../shared/services/activity-statuses.service";
import {RequestAttributesService} from "../../shared/services/request-attributes.service";
import {RequestPrioritiesService} from "../../shared/services/request-priorities.service";
import {AttachmentTypesService} from "../../shared/services/attachment-types.service";
import {RegionsService} from "../../shared/services/regions.service";
import { RequestTypeService } from '../../shared/services/request-type.service';
import {MerchantsService} from "../../categories/merchants/merchants.service";
import {AgreementsService} from "../../shared/services/agreements.service";
import {CategoryServicesService} from "../../shared/services/category-services.service";
import {ServiceCategoriesService} from "../../shared/services/service-categories.service";
import {ServiceTypesService} from "../../shared/services/service-types.service";
import {ServiceModesService} from "../../shared/services/service-modes.service";
import {ServiceCentersService} from "../../shared/services/service-centers.service";
import { RolesService } from '../../admin/roles';
import { ExportExcelFromGridService } from '../../shared/services/export-excel-from-grid.service';
import { WarehouseWorkplaceRequestsService } from '../../shared/services/warehouse-workplace-requests.service';
import { IdleService } from '../../shared/services/idle.service';
import { FileUtil } from '../../shared/utils';
import { FinancialReconciliationReportResult } from '../../shared/models/request/financial-reconciliation-report-result';

declare var kendo: any;

@Component({
	selector: 'requests',
	templateUrl: './list.page.html',
	styleUrls: [
		'../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'./list.page.scss'],
	encapsulation: ViewEncapsulation.None,
	/*providers: [IdleService]*/
})
export class RequestsListPage extends ListPageBase<RequestListItem> implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild('filterAllInput') filterAllInput: ElementRef;
	@ViewChild('userFiltersModal') userFiltersModal: any;
	@ViewChild('yaMap') yaMap: MapYaComponent;
	@ViewChild('fileInput') fileInput: any;
	@ViewChild("requestsGrid") requestsGrid: GridComponent;

	requestListSubscription: Subscription = null;
	requestListSubsMobile : Subscription[] = [];

	requestTypes: KeyValueObject[] = [];
	requestCategories: KeyValueObject[] = [];
	serviceCenters: KeyValueObject[] = [];
	carriers: KeyValueObject[] = [];
	costCenters: KeyValueObject[] = [];
	contragentProjects: KeyValueObject[] = [];
	gridSelectedRequestIds: number[] = [];
	userFilters: UserFilter[] = [];

	reconciliations: KeyValueObject[] = new Array(new KeyValueObject(1, "Да"), new KeyValueObject(0, "Нет"));

	isMap: boolean = false;
	isMapSwitcherOn: boolean = false;
	isGroupClick: boolean = false;

	lastFilterText = '';
	public dataGenerating = false;
	public dataGeneratingFin = false;
	public loadingFinancialReconciliation: boolean = false;
	public downloadingFinancialReconciliationTemplate: boolean = false;
	public setDefaultFiltersIsInProgress: number[] = [];
	public removeFiltersIsInProgress: number[] = [];

	private readonly _refreshTime: number;
	private _lastRefreshTime?: Date = null;

	private _destroy$ = new Subject<boolean>();

	isIdle = false;

	throttle = 300;
	scrollDistance = 1;
	selectedTab = 1;
	selectedRequestStatus = 12;
	selectedDate = 'today';
	selectedOrder = null;
	showTomorrow = false;
	showDays = [];
	public openedSearchModal = false;
	searchRequests: RequestListItem[] = [];
	searchRequestsSize: number = 0;
	delaySearch = null;

	readonly TAB_ASSIGNED: number = 1;
	readonly TAB_STOPPED: number = 2;
	readonly TAB_COMPLETED: number = 3;

	toggledAccordions: Map<number, boolean> = new Map();
	alwaysToggled = false;

	reconciliationDialog: DialogRef;

	constructor(
		private sanitizer: DomSanitizer,
		protected appService: AppService,
		router: Router,
		private modalService: NgbModal,
		protected dataService: RequestsService,
		protected persistingService: StatePersistingService,
		private lookupService: LookupService,
		protected dialogService: DialogService,
		protected notificationService: NotificationService,
		protected exportExcelFromGridService: ExportExcelFromGridService,
		private userFiltersService: UserFiltersService,
		private securityService: SecurityService,
		public requestNotificationTypeService: RequestNotificationTypeService,
		private mapYaDataService: MapYaDataService,
		public userGroupsService: UserGroupsService,
		private signalRNotificationsService: SignalRNotificationsService,
		public usersDataService: UsersService,
		public initTypesService: InitTypesService,
		public requestStatusesService: RequestStatusesService,
		public requestStatusMspAliasGroupsService: RequestStatusMspAliasGroupsService,
		public activityStatusesService: ActivityStatusesService,
		public requestAttributesService: RequestAttributesService,
		public requestPrioritiesService: RequestPrioritiesService,
		public attachmentTypesService: AttachmentTypesService,
		public regionsService: RegionsService,
		public requestTypeDataService: RequestTypeService,
		public merchantsService: MerchantsService,
		public agreementsService: AgreementsService,
		public categoryServicesService: CategoryServicesService,
		public serviceCategoriesService: ServiceCategoriesService,
		public serviceTypesService: ServiceTypesService,
		public serviceModesService: ServiceModesService,
		public serviceCentersService: ServiceCentersService,
		protected contragentsDataService: ContragentsService,
		protected rolesDataService: RolesService,
		public warehouseWorkplaceRequestsService: WarehouseWorkplaceRequestsService,
		//private idleService: IdleService
	) {
		super(router, appService, dataService, persistingService, exportExcelFromGridService);
		this.groupedKey = 'createdDateGroupValue';
		appService.pageTitle = 'Заявки';
		this._refreshTime = this._getMsTime(environment.requestListRefreshTime);
		this.alwaysToggled = localStorage.getItem('alwaysToggled') === 'true';
		this.filtersBlockCollapsedStorageKey = 'requestsListFiltersBlockCollapsed';
		this.restoreFiltersBlockCollapsedState();
	}

	public loadData(state: DataSourceRequestState = this.gridSettings.state): void {
		this.loading = true;

		var visibleColumnNames = this.gridSettings.columnsConfig.filter(x => !x.hidden).map(x => x.field);

		this.setGridSettingsState(this.gridSettings);

		if (this.requestListSubscription !== null)
			this.requestListSubscription.unsubscribe();

		this.requestListSubscription = this.dataService.requestList(state, visibleColumnNames).subscribe(lvm => {
			this.processListItems(lvm.data);
			this.listViewModel = lvm;
			this.groupedData = this.groupedByKey;
			this.loading = false;
		});
	}

	public columnColor(statusColorCode: string, slaColorCode: string, isInRms: boolean): SafeStyle {
		if (isInRms) {
			return this.sanitizer.bypassSecurityTrustStyle("#d9d9d9");
		}

		if (slaColorCode) {
			return this.sanitizer.bypassSecurityTrustStyle(slaColorCode);
		}

		return this.sanitizer.bypassSecurityTrustStyle(statusColorCode);
	}

	public rowClass(context: RowClassArgs) {
		if (context.dataItem.hoursToDeadline) {

			let splitHours: number = 0;
			let hours: number = 0;
			let minutes: number = 0;
			let splitDays: number = 0;
			let days: number = 0;

			if (context.dataItem.hoursToDeadline.includes(".")) {
				splitDays = context.dataItem.hoursToDeadline.split(".");
				days = parseInt(splitDays[0]);
			} else {
				splitHours = context.dataItem.hoursToDeadline.split(":");
				hours = parseInt(splitHours[0]);
				minutes = parseInt(splitHours[1]);
			}

			if ((days < 0) || (hours < -3 || (hours === -3 && minutes > 0))) {
				return {
					'cursor-pointer': true,
					'red-text': true
				};
			} else {
				return {
					'cursor-pointer': true
				};
			}

		} else {
			return {
				'cursor-pointer': true
			};
		}
	}

	filterChange(): void {
		this.gridSelectedRequestIds = [];
		this.mapYaDataService.changeFilters(this.gridSettings.state);
	}

	public testExpand() {
		console.log("expand");
	}

	public testCollapse() {
		console.log("collapse");
	}

	public enableSaveGridSettings: boolean = true;

	gridSettingsStorageKey: string = 'request-grid-settings-v6';
	gridSettingsFilterStorageKey: string = 'request-grid-settings-filter-v6';
	selectedUserFilterStorageKey: string = 'request-selected-user-filter';

	public gridColumnOffset: number = 1;

	public gridSettingsFilter: GridSettings = {
		state: {
			skip: 0,
			take: 25,
			sort: [{ field: 'requestIdStr', dir: 'desc' }],
			filter: { logic: 'and', filters: [] }
		},
		columnsConfig: [
			{
				orderIndex: 0,
				field: 'requestIdStr',
				title: '# заявки',
				filter: 'string',
				filterable: true,
				width: 150,
				hidden: false
			},
			{
				orderIndex: 1,
				field: 'internalNumber',
				title: 'Внутренний номер',
				filter: 'string',
				filterable: true,
				width: 200,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'createdDateLocal',
				title: 'Дата создания',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 350,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'externalId',
				title: '# заявки заказчика',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false,
			},
			{
				orderIndex: 4,
				field: 'initTypeName',
				title: 'Источник',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'initTypeId'
			},
			{
				orderIndex: 5,
				field: 'requestTypeName',
				title: 'Тип заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'requestTypeId'
			},
			{
				orderIndex: 6,
				field: 'statusName',
				title: 'Статус заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'statusId'
			},
			{
				orderIndex: 7,
				field: 'categoryName',
				title: 'Линейка продукции',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'categoryId'
			},
			{
				orderIndex: 8,
				field: 'performerUserGroupName',
				title: 'Группа исполнителя',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'performerUserGroupId'
			},
			{
				orderIndex: 9,
				field: 'performerUserName',
				title: 'Исполнитель',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'performerUserId'
			},
			{
				orderIndex: 28,
				field: 'openActivityPerformerUserName',
				title: 'Исполнители открытой активности',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'openActivityPerformerUserId'
			},
			{
				orderIndex: 10,
				field: 'authorUserGroupName',
				title: 'Группа автора',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'authorUserGroupId'
			},
			{
				orderIndex: 11,
				field: 'authorUserName',
				title: 'Автор',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'authorUserId'
			},
			{
				orderIndex: 12,
				field: 'customerContragentName',
				title: 'Клиент',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'customerContragentId'
			},
			{
				orderIndex: 13,
				field: 'tspAddress',
				title: 'Адрес ТСП',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 14,
				field: 'description',
				title: 'Описание',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: true
			},
			{
				orderIndex: 15,
				field: 'lastActivityStatusName',
				title: 'Статус последней активности',
				filter: 'lookup',
				filterable: true,
				width: 350,
				hidden: true,
				filterField: 'lastActivityStatusId'
			},
			{
				orderIndex: 16,
				field: 'finishDateLocal',
				title: 'Дата завершения',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 350,
				hidden: true
			},
			{
				orderIndex: 17,
				field: 'stoppedUntilLocal',
				title: 'Остановлено до',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 350,
				hidden: false
			},
			{
				orderIndex: 18,
				field: 'endOfSlaDateLocal',
				title: 'Дата окончания работ',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 350,
				hidden: true
			},
			{
				orderIndex: 19,
				field: 'attachmentTypesString',
				title: 'Вложения',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'attachmentTypesCustomFilter'
			},
			{
				orderIndex: 20,
				field: 'lastRequestComment',
				title: 'Текст последнего комментария в заявке',
				filter: 'string',
				filterable: false,
				width: 450,
				hidden: true
			},
			{
				orderIndex: 21,
				field: 'agreementNumber',
				title: 'Договор',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'agreementId'
			},
			{
				orderIndex: 22,
				field: 'serviceNames',
				title: 'Услуги',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'serviceId'
			},
			{
				orderIndex: 23,
				field: 'completedSerialNumbers',
				title: 'Установленные/демонтированные С/Н',
				filter: 'string',
				filterable: true,
				width: 350,
				hidden: false,
			},
			{
				orderIndex: 24,
				field: 'plannedDateLocal',
				title: 'Выезд запланирован',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 350,
				hidden: false
			},
			{
				orderIndex: 25,
				field: 'customerContragentPhoneNumber',
				title: 'Телефон клиента',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: true,
			},
			{
				orderIndex: 26,
				field: 'serviceCenterName',
				title: 'Филиал',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'serviceCenterId'
			},
			{
				orderIndex: 27,
				field: 'responsibleUserName',
				title: 'Ответственный менеджер',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 28,
				field: 'costCenterName',
				title: 'Кост-центр',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'costCenterId'
			},
			{
				orderIndex: 29,
				field: 'contragentProjectName',
				title: 'Проект',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'contragentProjectId'
			},
			{
				orderIndex: 63,
				field: 'carrierName',
				title: 'Транспортная компания',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'carrierId'
			},
			{
				orderIndex: 64,
				field: 'trackNumber',
				title: 'Номер накладной ТК',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: true
			}
		]
	};

	public gridSettings: GridSettings = {
		state: {
			skip: 0,
			take: 25,
			sort: [{ field: 'requestIdStr', dir: 'desc' }],
			filter: { logic: 'and', filters: [] }
		},
		columnsConfig: [
			{
				orderIndex: 0,
				field: 'requestIdStr',
				title: '# заявки',
				filter: 'string',
				filterable: true,
				width: 150,
				hidden: false

			},
			{
				orderIndex: 1,
				field: 'internalNumber',
				title: 'Внутренний номер',
				filter: 'string',
				filterable: true,
				width: 200,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'createdDateLocal',
				title: 'Дата создания',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 280,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'externalId',
				title: '# заявки заказчика',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false,
			},
			{
				orderIndex: 4,
				field: 'initTypeName',
				title: 'Источник',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'initTypeId'
			},
			{
				orderIndex: 5,
				field: 'requestTypeName',
				title: 'Тип заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'requestTypeId'
			},
			{
				orderIndex: 6,
				field: 'statusName',
				title: 'Статус заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'statusId'
			},
			{
				orderIndex: 7,
				field: 'categoryName',
				title: 'Линейка продукции',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'categoryId'
			},
			{
				orderIndex: 8,
				field: 'performerUserGroupName',
				title: 'Группа исполнителя',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'performerUserGroupId'
			},
			{
				orderIndex: 9,
				field: 'performerUserName',
				title: 'Исполнитель',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'performerUserId'
			},
			{
				orderIndex: 28,
				field: 'openActivityPerformerUserName',
				title: 'Исполнители открытой активности',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'openActivityPerformerUserId'
			},
			{
				orderIndex: 10,
				field: 'authorUserGroupName',
				title: 'Группа автора',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'authorUserGroupId'
			},
			{
				orderIndex: 11,
				field: 'authorUserName',
				title: 'Автор',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'authorUserId'
			},
			{
				orderIndex: 12,
				field: 'customerContragentName',
				title: 'Клиент',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'customerContragentId'
			},
			{
				orderIndex: 13,
				field: 'tspAddress',
				title: 'Адрес ТСП',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 14,
				field: 'description',
				title: 'Описание',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: true
			},
			{
				orderIndex: 15,
				field: 'lastActivityStatusName',
				title: 'Статус последней активности',
				filter: 'lookup',
				filterable: true,
				width: 350,
				hidden: true,
				filterField: 'lastActivityStatusId'
			},
			{
				orderIndex: 16,
				field: 'finishDateLocal',
				title: 'Дата завершения',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 300,
				hidden: true
			},
			{
				orderIndex: 17,
				field: 'stoppedUntilLocal',
				title: 'Остановлено до',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 18,
				field: 'endOfSlaDateLocal',
				title: 'Дата окончания работ',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 300,
				hidden: true
			},
			{
				orderIndex: 19,
				field: 'attachmentTypesString',
				title: 'Вложения',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'attachmentTypesCustomFilter'
			},
			{
				orderIndex: 20,
				field: 'lastRequestComment',
				title: 'Текст последнего комментария в заявке',
				filter: 'string',
				filterable: false,
				width: 400,
				hidden: true
			},
			{
				orderIndex: 21,
				field: 'agreementNumber',
				title: 'Договор',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'agreementId'
			},
			{
				orderIndex: 22,
				field: 'serviceNames',
				title: 'Услуги',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'serviceId'
			},
			{
				orderIndex: 23,
				field: 'completedSerialNumbers',
				title: 'Установленные/демонтированные С/Н',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false,
			},
			{
				orderIndex: 24,
				field: 'plannedDateLocal',
				title: 'Выезд запланирован',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 25,
				field: 'customerContragentPhoneNumber',
				title: 'Телефон клиента',
				filter: 'string',
				filterable: true,
				width: 250,
				hidden: true,
			},
			{
				orderIndex: 26,
				field: 'serviceCenterName',
				title: 'Филиал',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'serviceCenterId'
			},
			{
				orderIndex: 27,
				field: 'responsibleUserName',
				title: 'Ответственный менеджер',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 28,
				field: 'costCenterName',
				title: 'Кост-центр',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'costCenterId'
			},
			{
				orderIndex: 29,
				field: 'contragentProjectName',
				title: 'Проект',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'contragentProjectId'
			},
			{
				orderIndex: 63,
				field: 'carrierName',
				title: 'Транспортная компания',
				filter: 'lookup',
				filterable: true,
				width: 350,
				hidden: true,
				filterField: 'carrierId'
			},
			{
				orderIndex: 64,
				field: 'trackNumber',
				title: 'Номер накладной ТК',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: true
			}
		]
	};

	protected gridColumnRightProcess(settings: GridSettings) {
		if (!settings || !settings.columnsConfig || settings.columnsConfig.some(x => x.field === 'categoryName')) {
			return;
		}

		settings.columnsConfig
			.filter(x => x.orderIndex >= 7 && x.orderIndex < 63)
			.forEach(x => x.orderIndex++);

		settings.columnsConfig.push({
			orderIndex: 7,
			field: 'categoryName',
			title: 'Линейка продукции',
			filter: 'lookup',
			filterable: true,
			width: 300,
			hidden: false,
			filterField: 'categoryId'
		});
	}

	onListPageInit(): void {

		if (this.isMobileDevice)
			return;
		this.gridColumnRightProcess(this.gridSettings);
		this.lookupService.getData("request-types", null).subscribe(data => this.requestTypes = data);
		this.lookupService.getData("request-categories", null).subscribe(data => this.requestCategories = data);
		this.lookupService.getData("service-centers", null).subscribe(data => this.serviceCenters = data);
		this.lookupService.getData("carriers", null).subscribe(data => this.carriers = data);
		this.lookupService.getData("cost-centers", null).subscribe(data => this.costCenters = data);
		this.lookupService.getData("contragent-projects", null).subscribe(data => this.contragentProjects = data);

		this.loadUserFilters(null);
	}

	loadUserFilters(selectedUserFilterId?: number) {

		this.loading = true;

		this.userFiltersService.list({
			skip: 0,
			take: null,
			filter: { logic: "and", filters: [{ field: "userFilterTypeId", operator: "eq", value: <number>UserFilterType.Requests }] }
		}).subscribe(x => {
			this.userFilters = x.data;

			if (selectedUserFilterId != null) {
				var filtered = this.userFilters.filter(x => x.userFilterId === selectedUserFilterId);

				if (filtered.length > 0) {
					this.setUserFilter(filtered[0]);
				}
			} else {
				var storedUserFilter = this.findStoredUserFilter();

				if (storedUserFilter != null) {
					this.setUserFilter(storedUserFilter);
				} else {
					var filtered = this.userFilters.filter(x => x.isDefault);

					if (filtered.length > 0) {
						this.setUserFilter(filtered[0]);
					} else {
						this.setLocalFilter();
					}
				}
			}

		});
	}

	clearFilters(): void {
		this.selectedUserFilter = null;
		this.removeSelectedUserFilterFromStorage();

		this.gridSettings.state = {
			skip: 0,
			take: this.gridSettings.state.take,
			sort: [{ field: 'requestIdStr', dir: 'desc' }],
			filter: { logic: 'and', filters: [] }
		};

		this.gridSettingsFilter.state = {
			skip: 0,
			take: this.gridSettings.state.take,
			sort: [{ field: 'requestIdStr', dir: 'desc' }],
			filter: { logic: 'and', filters: [] }
		};

		if (this.enableSaveGridSettings) {
			this.saveGridSettings();
			this.saveGridSettings(true);
		}

		this.appService.clearAllGridFilters.next();

		this.loadData();
	}

	public ngOnInit(): void {

		this.gridColumnRightProcess(this.gridSettings);
		const gridSettings: GridSettings = this.persistingService.get(this.gridSettingsStorageKey);
		this.gridColumnRightProcess(gridSettings);
		this.setGridSettings(gridSettings);

		this.gridColumnRightProcess(this.gridSettingsFilter);
		const gridSettingsFilter: GridSettings = this.persistingService.get(this.gridSettingsFilterStorageKey);
		this.gridColumnRightProcess(gridSettingsFilter);
		this.setGridSettings(gridSettingsFilter, true);

		if (this.isMobileDevice) {
			this.gridSettings.state.filter.filters = [this.getFilters(this.selectedDate)];
			this.gridSettings.state.sort = [{ field: 'requestIdStr', dir: 'desc' }];
		}

		this.onListPageInit();

		if (!(this.isMobileDevice)) {
			this._initUserSearchListening();
		}

		this.signalRNotificationsService.context = this;
		this.signalRNotificationsService.onFinancialReconciliationCompleted = this.onLoadFinancialReconciliationCompleted;
		this.signalRNotificationsService.onSignalRConnected = this.onSignalRConnected;

		if (this.showMobileView) {
			setTimeout(() => this.selectDateFilter('today'), 100);
		}

		this._initIdleService();
	}

	ngAfterViewInit(): void {
		this.syncMainGridHeight();

		if (!this.filterAllInput)
			return;

		fromEvent(this.filterAllInput.nativeElement, 'keyup')
			.pipe(
				map((evt: any) => evt.target.value),
				debounceTime(500),
				distinctUntilChanged(),
			).subscribe((text: string) => this.onFilter(text));
	}

	public ngOnDestroy() {
		if (this.requestListSubscription !== null)
			this.requestListSubscription.unsubscribe();

		this.signalRNotificationsService.onFinancialReconciliationCompleted = null;
		this.signalRNotificationsService.context = null;
		this._destroy$.next(true);
		this._destroy$.complete();
	}

	processListItems(items: RequestListItem[]): void {
		items.forEach(x => {
			x.createdDate = this.appService.parseDate(x.createdDate);
			if (x.finishDate !== null) {
				x.finishDate = this.appService.parseDateTime(x.finishDate);
			}
			if (x.stoppedUntil !== null) {
				x.stoppedUntil = this.appService.parseDateTime(x.stoppedUntil);
			}
		});
		this._updateRefreshTime();
	}

	public cellMobileClick(dataItem) {
		var request = (<RequestListItem>dataItem);
		this.router.navigate(['/requests', request.requestId]);
	}

	public cellClick({ type, dataItem, column }: any): void {

		var request = (<RequestListItem>dataItem);

		if (column instanceof CheckboxColumnComponent) {

			if (this.gridSelectedRequestIds.some(x => x === request.requestId)) {
				this.gridSelectedRequestIds = this.gridSelectedRequestIds.filter(x => x !== request.requestId);
			} else {
				this.gridSelectedRequestIds.push(dataItem.requestId);
			}

		} else if (type === "click") {
			let col = <ColumnComponent>column;
			if (col.field !== 'requestIdStr') {
				this.router.navigate(['/requests', request.requestId]);
			}
		} else {
			this.isGroupClick = request.requestTypeId === <number>RequestType.groupRequest;
		}
	}

	public onContextMenuClick({ item, dataItem }: any): void {
		if (item === "Показать группу целиком") {
			this.requestsGrid.filterable = false;

			var request = (<RequestListItem>dataItem);


		} else if (item === "Перейти к активностям") {

			if (!dataItem.hasActivities) {
				this.notificationService.warning({
					title: 'Активности',
					message: 'Выбранная заявка не содержит активностей!',
					notificationType: NotificationType.SweetAlert
				});

				return;
			}

			this.router.navigate(['/requests', dataItem.requestId]);
		}
		else if (item === "Планировать в Veeroute") {
			const dialogRef = this.dialogService.open({ content: VeerouteCalendarComponent, title: "Планирование в Veeroute" });
			const veerouteCalendarComponent = <VeerouteCalendarComponent>dialogRef.content.instance;
			veerouteCalendarComponent.value = new Date();
			veerouteCalendarComponent.requestIds = this.gridSelectedRequestIds;
		}
		else if (item === "Перенести в РМС") {
			let requestIds = [dataItem.requestId];

			if (!!this.gridSelectedRequestIds && this.gridSelectedRequestIds.length > 0) {
				requestIds = this.gridSelectedRequestIds;
			}

			this.warehouseWorkplaceRequestsService.addWarehouseWorkplaceRequests(requestIds).subscribe(res => {
				if(res.isSuccessful) {
					requestIds.forEach(f => {
						let requestData = this.listViewModel.data.find(fi => fi.requestId == f);
					});

					this.notificationService.success({
						title: '',
						message: 'Заявки перенесены в РМС',
						notificationType: NotificationType.Toast
					});
				}
			});
		} else {
			const dialogRef = this.dialogService.open({ content: MultipleOperationsComponent, width: '70%', height: '70%' });

			const multipleOperationsComponent = <MultipleOperationsComponent>dialogRef.content.instance;
			multipleOperationsComponent.requestIds = this.listViewModel.data.filter(val => this.gridSelectedRequestIds.includes(val.requestId)).map(m => m.requestId);
			multipleOperationsComponent.tabName = item;
			multipleOperationsComponent.heightPercent = 48;

			multipleOperationsComponent.applyEventOnResetCheckboxes.subscribe(() => {
				this.gridSelectedRequestIds = [];
			});
		}
	}

	public onRequestsReport(): void {
		this.dataGenerating = true;

		this.getXlsx('requests', 'Заявки.xlsx',
			(c) => {
				c.forEach(f => {
					if (f.field === "sla") {
						f.field = "slaAsTimeSpanString";
						f.filter = "string";
					}
				});
			},
			() => {
				this.dataGenerating = false;
			});
	}

	public onLoadFinancialReconciliation(file: File): void {
		this.loadingFinancialReconciliation = true;
		this.signalRNotificationsService.startConnection().subscribe(() => {
			this.signalRNotificationsService.initReconciliation(file);
		});
	}

	public downloadFinancialReconciliationTemplate(): void {
		this.downloadingFinancialReconciliationTemplate = true;
		this.dataService.downloadFinancialReconciliationTemplate()
		.subscribe(result => {
			if (result.isSuccessful) {
				const bytes = FileUtil.base64ToArrayBuffer(result.data.data);
				const blob = new Blob([bytes], { type: result.data.extension });
				saveAs(blob, result.data.fileName);
			}
			this.downloadingFinancialReconciliationTemplate = false;
		}, error => this.downloadingFinancialReconciliationTemplate = false);
	}

	public onSignalRConnected(context: RequestsListPage, file: File): void {
		context.dataService.loadFinancialReconciliation(file[0]).subscribe(x => {
			if (x.isSuccessful) {
				context.reconciliationDialog = context.dialogService.open({ content: LoadFinancialReconciliationWarningComponent });
			}

			context.fileInput.nativeElement.value = '';
			context.loadingFinancialReconciliation = false;
		}, () => {
			context.fileInput.nativeElement.value = '';
			context.loadingFinancialReconciliation = false;
		});
	}

	public onLoadFinancialReconciliationCompleted(context: RequestsListPage, response: FinancialReconciliationReportResult): void {
		
		if (context.reconciliationDialog) {
			context.reconciliationDialog.close();
		}
		if (response && response.errorItems && response.errorItems.length > 0) {
			const dialogRef = context.dialogService.open({ content: MultipleOperationErrorResultComponent, width: '50%', height: '50%' });

			const multipleOperationErrorResultComponent = <MultipleOperationErrorResultComponent>dialogRef.content.instance;
			multipleOperationErrorResultComponent.errors = response.errorItems;
			multipleOperationErrorResultComponent.heightPercent = 53;
			multipleOperationErrorResultComponent.headerText = "Все заявки обработаны корректно, кроме:";
		} else {
			context.notificationService.success({
				title: 'Файл обработан успешно',
				message: 'Сверка проведена успешно!',
				notificationType: NotificationType.SweetAlert
			});
		}

		if (response && response.fileData) {
			const bytes = FileUtil.base64ToArrayBuffer(response.fileData);
				const blob = new Blob([bytes], { type: '.xlsx'});
				saveAs(blob, "Результат сверки.xlsx");
		}
	}

	public onFilter(inputValue: string): void {
		this.lastFilterText = inputValue;

		this.loadData(this.getCustomState(inputValue));
	}

	private getCustomState(inputValue: string): DataSourceRequestState {
		return {
			skip: 0,
			take: this.gridSettings.state.take,
			sort: this.gridSettings.state.sort,
			filter: {
				logic: "or",
				filters: [
					{
						field: 'requestIdStr',
						operator: 'eq',
						value: inputValue
					},
					{
						field: 'initTypeName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'requestTypeName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'categoryName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'statusName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'partnerStatusAliasName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'performerUserGroupName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'performerUserName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'authorUserGroupName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'authorUserName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'customerContragentName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'tspName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'tspAddress',
						operator: 'contains',
						value: inputValue
					},
					// {
					// 	field: 'description',
					// 	operator: 'contains',
					// 	value: inputValue
					// },
					{
						field: 'lastActivityStatusName',
						operator: 'contains',
						value: inputValue
					},
				],
			}
		};

	}

	private _initUserSearchListening(): void {
		this._updateRefreshTime();

		const interval$ = from(interval(this._refreshTime))
			.pipe(
				filter(x => (new Date().getTime() - this._lastRefreshTime.getTime() >= this._refreshTime) && !this.loading && !this.isIdle),
				takeUntil(this._destroy$)
			);

		interval$.subscribe(() => {
			this.loadData();
			if (this.isMap) {
				this.yaMap.initMapData();
			}
		});
	}

	private _updateRefreshTime(): void {
		this._lastRefreshTime = new Date();
	}

	private _getMsTime(seconds: number): number {
		return seconds * 1000;
	}

	get isMobileDevice(): boolean {
		return this.appService.isMobileDevice;
	}

	public get showMobileView(): boolean {
		return false;
	}

	public initialized: boolean = false;

	setUserFilter(userFilter: UserFilter) {
		this.selectedUserFilter = userFilter;
		this.saveSelectedUserFilter(userFilter);

		var localFilter = localStorage.getItem(this.gridSettingsFilterStorageKey);
		const currentTake = this.gridSettings.state.take;
		const currentSort = this.gridSettings.state.sort;

		if (!this.isMobileDevice && (localFilter == null || localFilter != userFilter.filterExpression)) {
			var userFilterGridSettings = JSON.parse(userFilter.filterExpression);
			this.gridColumnRightProcess(userFilterGridSettings);

			// Выбор фильтра меняет только грид фильтров, не настройки отображения
			this.setGridSettings(userFilterGridSettings, true);

			// Критерии фильтрации для загрузки данных; pageSize и сортировку не трогаем
			if (userFilterGridSettings.state) {
				this.gridSettings.state.filter = userFilterGridSettings.state.filter;
				this.gridSettings.state.sort = currentSort;
				this.gridSettings.state.skip = 0;
				this.gridSettings.state.take = currentTake;

				if (this.gridSettingsFilter.state) {
					this.gridSettingsFilter.state.take = currentTake;
					this.gridSettingsFilter.state.skip = 0;
					this.gridSettingsFilter.state.sort = currentSort;
				}
			}

			this.saveGridSettings(true);
			this.saveGridSettings();
		}

		this.loadData();

		this.mapYaDataService.changeFilters(this.gridSettings.state);

		this.initialized = true;
	}

	private saveSelectedUserFilter(userFilter: UserFilter): void {
		localStorage.setItem(this.selectedUserFilterStorageKey, JSON.stringify({
			name: userFilter.name,
			userFilterId: userFilter.userFilterId
		}));
	}

	private removeSelectedUserFilterFromStorage(): void {
		localStorage.removeItem(this.selectedUserFilterStorageKey);
	}

	private findStoredUserFilter(): UserFilter | null {
		const storedRaw = localStorage.getItem(this.selectedUserFilterStorageKey);

		if (storedRaw == null) {
			return null;
		}

		let stored: { name?: string; userFilterId?: number };

		try {
			stored = JSON.parse(storedRaw);
		} catch {
			return null;
		}

		if (stored.name != null) {
			const byName = this.userFilters.filter(x => x.name === stored.name);

			if (byName.length > 0) {
				return byName[0];
			}
		}

		if (stored.userFilterId != null) {
			const byId = this.userFilters.filter(x => x.userFilterId === stored.userFilterId);

			if (byId.length > 0) {
				return byId[0];
			}
		}

		return null;
	}

	setLocalFilter() {
		var localFilter = this.persistingService.get<GridSettings>(this.gridSettingsStorageKey);

		if (localFilter != null && !this.isMobileDevice) {
			this.setGridSettings(localFilter);
			this.saveGridSettings();
		}

		var localFilter2 = this.persistingService.get<GridSettings>(this.gridSettingsFilterStorageKey);

		if (localFilter2 != null && !this.isMobileDevice) {
			this.setGridSettings(localFilter2, true);
			this.saveGridSettings(true);
		}

		this.loadData();
		this.checkTomorrowRequests();

		this.mapYaDataService.changeFilters(this.gridSettings.state);

		this.initialized = true;
	}

	newFilter() {
		this.notificationService.newItemInput({ inputPlaceholder: "Введите название для нового фильтра" },
			(newFilterName) => {

				if (!!newFilterName) {
					this.userFiltersService.create({
						name: newFilterName,
						filterExpression: JSON.stringify({
							columnsConfig: this.gridSettingsFilter.columnsConfig,
							state: {
								skip: 0,
								take: this.gridSettings.state.take,
								sort: this.gridSettings.state.sort,
								filter: this.gridSettings.state.filter
							}
						}),
						isDefault: this.userFilters.length == 0,
						userFilterTypeId: <number>UserFilterType.Requests,
						userFilterId: null,
						userId: null
					}).subscribe(x => {
						this.loadUserFilters(x.data);
					})
				}
			})
	}

	userFilterSettings() {
		this.modalService.open(this.userFiltersModal, { windowClass: 'modal-top modal-sm' }).result.then((result) => {

		}, (reason) => {

		});
	}

	setUserFilterAsDefault(userFilter: UserFilter) {

		this.switchOnInProgressFlag(this.setDefaultFiltersIsInProgress, userFilter.userFilterId);

		this.userFiltersService.setDefaultUserFilter(userFilter.userFilterId).subscribe(x => {
			this.switchOffInProgressFlag(this.setDefaultFiltersIsInProgress, userFilter.userFilterId);
			this.loadUserFilters();
		});
	}

	unsetUserFilterAsDefault(userFilter: UserFilter) {
		this.switchOnInProgressFlag(this.setDefaultFiltersIsInProgress, userFilter.userFilterId);

		this.userFiltersService.setDefaultUserFilter(null).subscribe(x => {
			this.switchOffInProgressFlag(this.setDefaultFiltersIsInProgress, userFilter.userFilterId);
			this.loadUserFilters();
		});
	}

	removeUserFilter(userFilter: UserFilter) {

		this.switchOnInProgressFlag(this.removeFiltersIsInProgress, userFilter.userFilterId);

		this.userFiltersService.remove(`${userFilter.userFilterId}`, "Пользовательские фильтры", "Фильтр успешно удален").subscribe(x => {
			this.loadUserFilters();

			this.switchOffInProgressFlag(this.removeFiltersIsInProgress, userFilter.userFilterId);
		});
	}

	switchOnInProgressFlag(items: number[], id: number) {
		items.push(id);
	}

	switchMap(): void {
		if (!this.isMap && this.listViewModel.total > 1000) {
			this.notificationService.confirmation({
				title: 'Возможное снижение производительности',
				message: 'Выбрано большое 1000 заявок. Желаете продолжить?',
				type: 'question',
				confirmButtonText: 'Да',
				cancelButtonText: 'Нет',
				showCloseButton: true
			},
				() => {
					this.isMap = !this.isMap;
				},
				() => {
					this.isMapSwitcherOn = false;
				});
		} else {
			this.isMap = !this.isMap;
		}
	}

	switchOffInProgressFlag(items: number[], id: number) {
		const index = items.indexOf(id, 0);

		if (index > -1) {
			items.splice(index, 1);
		}
	}

	onScrollDown() {

	}

	public get isEngineer() {
		return this.securityService.isEngineer();
	}

	public get isMobileEngneer() {
		return this.isMobileDevice && this.isEngineer;
	}

	public isSelectedTab(tab: number) {
		return this.selectedTab === tab;
	}

	public selectDateFilter(type) {
		this.selectedDate = type;
		this.filterLoad(this.getFilters(this.selectedDate));
	}

	public selectDateOrder(type) {
		if (this.selectedOrder === type) {
			this.selectedOrder = null;
		} else {
			this.selectedOrder = type;
		}
		this.filterLoad(this.getFilters(this.selectedDate));
	}

	private filterLoad(filter : CompositeFilterDescriptor) {
		this.gridSettings.state.skip = 0;
		this.gridSettings.state.filter.filters = [filter];
		this.gridSettings.state.sort = this.getSort()
		this.loadData();
		this.checkTomorrowRequests();
	}

	private checkTomorrowRequests() {

		if (this.selectedTab === 1 && this.isMobileDevice) {
			this.dataService.slaDates().subscribe(lvm => {
				// for test
				// lvm = ["05.06", "06.06", "07.06", "08.06", "09.06", "10.06", "11.06", "12.06", "13.06"]
				var tommorow = new Date(new Date().setHours(24));
				var day = tommorow.getDate();
				var d = day >= 10 ? day.toString() : "0" + day.toString();
				var month = tommorow.getMonth() + 1;
				var m = month >= 10 ? month.toString() : "0" + month.toString();
				this.showTomorrow = lvm.includes(`${d}.${m}-${tommorow.getFullYear()}`);
				this.showDays = lvm.filter(p => p !== `${d}.${m}-${tommorow.getFullYear()}`).map(p => p.split('-')[0]);
			});
		}
	}

	private getSort() {
		const result = [];
		if (this.selectedOrder === 'client') {
			result.push({ field: 'customerContragentName', dir: 'asc' })
		} else if (this.selectedOrder === 'type') {
			result.push({ field: 'requestTypeName', dir: 'asc' })
		} else if (this.selectedOrder === 'address') {
			result.push({ field: 'tspAddress', dir: 'asc' })
		} else if (this.selectedOrder === 'sla') {
			result.push({ field: 'slaDueDateLocal', dir: 'asc' })
		} else {
			result.push({ field: 'requestIdStr', dir: 'desc' });
		}
		return result;
	}

	private getFilters(selectedDate: string): CompositeFilterDescriptor {
		let filter : CompositeFilterDescriptor= { logic: 'and', filters: []};
		return filter;
	}
	public onAssignTabChecked(){
		this.selectedDate = 'today';
		this.selectedTab = this.TAB_ASSIGNED;
		let filter: CompositeFilterDescriptor = this.getFilters(this.selectedDate);
		this.filterLoad(filter);
	}

	public onStoppedTabChecked(){
		this.selectedDate = 'today';
		this.selectedTab = this.TAB_STOPPED;
		let filter: CompositeFilterDescriptor = this.getFilters(this.selectedDate);
		this.filterLoad(filter);
	}

	public onCompletedTabChecked(){
		this.selectedDate = 'today';
		this.selectedTab = this.TAB_COMPLETED;
		let filter: CompositeFilterDescriptor = this.getFilters(this.selectedDate);
		this.filterLoad(filter);
	}

	private getDate(s) {
		return s.length < 2 ? "0" + s : s;
	}

	trackByFunction(index, item: ColumnSettings) {

		if (!item)
			return null;

		return item.field;

	}

	public close(status) {
		console.log(`Dialog result: ${status}`);
		this.openedSearchModal = false;
		this.searchRequests = [];
		this.searchRequestsSize = 0;
	}

	public open() {
		this.openedSearchModal = true;
	}

	public get searchRequestsSizeText() {
		return `Поиск. (${this.searchRequestsSize}) записей.`
	}

	public toggleAccordion(any) {
		if (this.toggledAccordions[any.index] !== undefined && this.toggledAccordions[any.index] !== null) {
			this.toggledAccordions[any.index] = any.active;
		} else {
			this.toggledAccordions.set(any.index, any.active);
		}
	}

	public isActiveAccordion(index: number) {
		return this.alwaysToggled || this.toggledAccordions[index];
	}

	public alwaysToggledChange() {
		this.alwaysToggled = !this.alwaysToggled;
		localStorage.setItem('alwaysToggled', this.alwaysToggled.toString());
	}

	get hasAddRequestClaim(): boolean {
		return this.securityService.hasClaim('cat-requests-add');
	}

	public onVisibilityChange(event: ColumnVisibilityChangeEvent, isFilter: boolean = false): void {
		if (!this.enableSaveGridSettings) {
			return;
		}
		this.actualizeHiddenColumnsFilteringAndSorting(event.columns);
		super.onVisibilityChange(event, isFilter);
		this.loadData();
	}

	private _initIdleService(){
		/*this.idleService.idleMessage = 'Вы долго не проявляли активность, поэтому обновление реестра заявок приостановлено.';
		this.idleService.getIdleStatus().subscribe((isIdle) => {
			this.isIdle = isIdle;
		});*/
	}

	customSortDisable(columnsConfig : ColumnSettings){
		if(columnsConfig.field === 'lastRequestComment' 
			|| columnsConfig.field === 'lastActivityComment'){
			return false;
		}
		return true;
	}
}
